export default __webpack_public_path__ + "static/media/regulatory--shared-path-pedestrians-and-bicycles--g1.bf20db10.png";